{
  "KPI": 57344,
  "PLU": 57345,
  "account-group": 57346,
  "account-hard-hat": 57347,
  "account-tie": 57348,
  "activity": 57349,
  "add": 57350,
  "add-circle": 57351,
  "albums-outline": 57352,
  "analytics": 57353,
  "android": 57354,
  "app-store": 57355,
  "apple": 57356,
  "archive": 57357,
  "arrow-down": 57358,
  "arrow-left": 57359,
  "arrow-right": 57360,
  "arrow-right-circle": 57361,
  "arrow-up-circle": 57362,
  "arrow-up-right": 57363,
  "attachment": 57364,
  "baby-carriage": 57365,
  "baguette": 57366,
  "barcode-scanner": 57367,
  "basket": 57368,
  "bed": 57369,
  "bread-slice": 57370,
  "broom": 57371,
  "calendar": 57372,
  "camera": 57373,
  "carrot": 57374,
  "cart": 57375,
  "cart-outline": 57376,
  "cash": 57377,
  "cash-register": 57378,
  "check": 57379,
  "cheese": 57380,
  "chevron-down": 57381,
  "chevron-left": 57382,
  "chevron-right": 57383,
  "chevron-up": 57384,
  "clear": 57385,
  "clock": 57386,
  "coffe": 57387,
  "connect": 57388,
  "connection-error": 57389,
  "cookie": 57390,
  "corner-down-right": 57391,
  "crown": 57392,
  "cupcake": 57393,
  "currency": 57394,
  "dashboard": 57395,
  "deadline": 57396,
  "desk-lamp": 57397,
  "developer": 57398,
  "dolly": 57399,
  "drag": 57400,
  "duplicate": 57401,
  "edit": 57402,
  "email": 57403,
  "employee-role": 57515,
  "expand-outline": 57404,
  "eye": 57405,
  "feedback": 57406,
  "file-minus": 57407,
  "files": 57408,
  "filter": 57409,
  "fish": 57410,
  "flag": 57411,
  "flower": 57412,
  "focus-mode": 57413,
  "food": 57414,
  "fork-knife": 57415,
  "forklift": 57416,
  "fridge": 57417,
  "google-play": 57418,
  "group-actor": 57419,
  "guest-actor": 57420,
  "hamburger": 57421,
  "hammer-wrench": 57422,
  "help": 57423,
  "hide": 57424,
  "image": 57425,
  "info": 57426,
  "instructions": 57427,
  "integration": 57428,
  "integration-flourish-praise": 57429,
  "iot": 57430,
  "issue": 57431,
  "key-outline": 57432,
  "laptop": 57433,
  "learn-more": 57434,
  "link": 57435,
  "locked": 57436,
  "log-in": 57437,
  "market": 57438,
  "meat": 57439,
  "message": 57440,
  "milk": 57441,
  "minus": 57442,
  "more": 57443,
  "more-outlined": 57444,
  "more-vertical": 57445,
  "notification": 57446,
  "number-input": 57447,
  "number-task": 57448,
  "org": 57449,
  "other": 57450,
  "phone": 57451,
  "pin": 57452,
  "pin-off": 57453,
  "pineapple": 57454,
  "play": 57455,
  "prio": 57456,
  "product": 57457,
  "remove": 57458,
  "remove-outline": 57459,
  "reorder": 57460,
  "routine": 57461,
  "routing": 57516,
  "rvm": 57462,
  "save-replace": 57463,
  "scan": 57464,
  "scan-barcode": 57465,
  "schedule": 57466,
  "search": 57467,
  "send": 57468,
  "settings": 57469,
  "show": 57470,
  "shuffle": 57471,
  "signal": 57472,
  "signal-cellular-2": 57473,
  "signal-cellular-3": 57474,
  "soda": 57475,
  "sofa": 57476,
  "star": 57477,
  "star-outlined": 57478,
  "steak": 57479,
  "store": 57480,
  "storesprint-update": 57481,
  "suggestion": 57482,
  "sun": 57483,
  "tag": 57484,
  "team-home": 57485,
  "team-layout": 57486,
  "team-schedule": 57487,
  "template": 57488,
  "text-edit": 57489,
  "text-input": 57490,
  "text-response": 57491,
  "text-task": 57492,
  "timezone": 57493,
  "todo-category": 57494,
  "todo-response": 57495,
  "topic": 57496,
  "touch": 57497,
  "trash": 57498,
  "truck": 57499,
  "tshirt": 57500,
  "tv": 57501,
  "tv-sharp": 57502,
  "update": 57503,
  "user": 57504,
  "user-add": 57505,
  "user-remove": 57506,
  "users": 57507,
  "verified-actor": 57508,
  "video": 57509,
  "watermelon": 57510,
  "widget": 57511,
  "winner": 57512,
  "workspace": 57513,
  "zap": 57514
}